import React from 'react';
import PropTypes from 'prop-types';
import Toast from "../../../../../../../components/WMS/Toast";
import {FormattedMessage} from "react-intl";
import ValidatedIcon from "assets/img/validated.svg";
import RedWarning from "assets/img/redWarning.svg"

TriShippinToast.propTypes = {
    open: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired
};

function TriShippinToast({open, type, handleClose}) {
    if (open) {
        switch (type) {
            case "containerSorted":
                return (
                    <Toast
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"validated-icon"}/> }
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.triShipping.finishSorting"}/>}
                    />
                )
            case "parcelSorted":
                return (
                    <Toast
                        icon={<img style={{height: '20px', width: '20px'}} src={ValidatedIcon} alt={"validated-icon"}/> }
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.triShipping.parcelSorted"}/>}
                    />
                )
            case "omniScanWrongNotFound":
                return (
                    <Toast
                        open={open}
                        handleClose={handleClose}
                        title={<FormattedMessage id={"wms.omniScan.notFound"}/>}
                        icon={<img style={{height: '20px', width: '20px'}} src={RedWarning} alt={"redwarning-icon"}/>}
                    />
                )
        }
    }
}

export default TriShippinToast;